
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("aPK9I", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.9f3679a2.js.map
